import { initialize, LDClient, LDContext } from 'launchdarkly-react-client-sdk';
import { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

interface LaunchDarklyContextType {
  ldClient: LDClient | null;
  isInitialized: boolean;
}

const LaunchDarklyContext = createContext<LaunchDarklyContextType>({
  ldClient: null,
  isInitialized: false,
});

export const useLaunchDarkly = () => useContext(LaunchDarklyContext);

export const LaunchDarklyProvider = ({ children }: { children: React.ReactNode }) => {
  const [ldClient, setLDClient] = useState<LDClient | null>(null);
  const [isInitialized, setIsInitialized] = useState(false);
  const { session } = useAuth();

  useEffect(() => {
    if (!session?.user?.email) return;

    const client = initialize(
      process.env.LAUNCHDARKLY_CLIENT_ID || '',
      {
        key: session.user.email,
        email: session.user.email,
      } as LDContext
    );

    client.on('ready', () => {
      setIsInitialized(true);
    });

    setLDClient(client);

    return () => {
      client.close();
    };
  }, [session?.user?.email]);

  return (
    <LaunchDarklyContext.Provider value={{ ldClient, isInitialized }}>
      {children}
    </LaunchDarklyContext.Provider>
  );
}; 